<template>
  <AnalyticsWidget
    title="Glass Size Summary"
    subTitle="Details about each glass size for the stock item"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th>Size</th>
          <th>Total Full Sheets</th>
          <th>Total Block Sheets</th>
          <th>Total Blocks</th>
          <th>Total Offcuts</th>
          <th>Total Area</th>
          <th>Moving Average</th>
          <th>Total Value</th>
          <th><Tooltip label="Percentage of area this item is in the entire inventory" helpStyle>Inventory Area</Tooltip></th>
          <th><Tooltip label="Percentage of value this item is in the entire inventory" helpStyle>Inventory Value</Tooltip></th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="glassSizeSummary of glassSizeSummaryList" :key="glassSizeSummary.id">
          <td>{{glassSizeSummary.height}} x {{glassSizeSummary.width}}</td>
          <td>{{glassSizeSummary.totalFullSheets}}</td>
          <td>{{glassSizeSummary.totalBlockSheets}}</td>
          <td>{{glassSizeSummary.totalBlocks}}</td>
          <td>{{glassSizeSummary.totalOffcuts}}</td>
          <td>{{formatDecimal(glassSizeSummary.totalArea, 2, true)}} m&sup2;</td>
          <td>{{formatCurrency(glassSizeSummary.unitPriceMovingAverage)}}</td>
          <td>{{formatCurrency(glassSizeSummary.totalStockOnHandValue)}}</td>
          <td>{{formatPercent(glassSizeSummary.percentageOfTotalArea)}}</td>
          <td>{{formatPercent(glassSizeSummary.percentageOfTotalValue)}}</td>
        </tr>
        <tr class="font-weight-bold highlight">
          <td>Totals</td>
          <td>{{totalFullSheets}}</td>
          <td>{{totalBlockSheets}}</td>
          <td>{{totalBlocks}}</td>
          <td>{{totalOffcuts}}</td>
          <td>{{formatDecimal(totalArea, 2, true)}} m&sup2;</td>
          <td></td>
          <td>{{formatCurrency(totalStockOnHandValue)}}</td>
          <td>{{formatPercent(totalPercentageOfTotalArea)}}</td>
          <td>{{formatPercent(totalPercentageOfTotalValue)}}</td>
        </tr>

      </template>
    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

export default {
  name: 'InventoryGlassSizeBreakdownWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    stockId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    totalFullSheets() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalFullSheets, 0)
    },
    totalBlockSheets() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalBlockSheets, 0)
    },
    totalBlocks() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalBlocks, 0)
    },
    totalOffcuts() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalOffcuts, 0)
    },
    totalArea() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalArea, 0)
    },
    totalStockOnHandValue() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.totalStockOnHandValue, 0)
    },
    totalPercentageOfTotalArea() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.percentageOfTotalArea, 0)
    },
    totalPercentageOfTotalValue() {
      return this.glassSizeSummaryList.reduce((sum, item) => sum + item.percentageOfTotalValue, 0)
    }
  },
  data() {
    return {
      loading: true,
      glassSizeSummaryList: []
    }
  },
  watch: {
    stockId: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      var params = {
        usageStartDate: moment().local().subtract(12, 'months').startOf('day').toDate().toISOString(),
        usageEndDate: moment().local().endOf('day').toDate().toISOString(),
        stockId: this.stockId
      }

      this.$apiService.analyticsService.getGlassSizeSummary(params)
      .then(response => {
        this.glassSizeSummaryList = response.data
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>